import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { formatApiErrorDetail } from "../lib/api";
import { PlanPill } from "../components/Badges";

export default function AdminDashboard() {
  const [cities, setCities] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ slug: "", name: "", state: "", lat: "", lng: "" });

  const refresh = () => {
    api.get("/cities").then((r) => setCities(r.data));
    api.get("/companies").then((r) => setCompanies(r.data));
    api.get("/admin/users").then((r) => setUsers(r.data)).catch(() => {});
  };

  useEffect(() => { refresh(); }, []);

  const addCity = async (e) => {
    e.preventDefault();
    try {
      await api.post("/cities", { ...form, lat: parseFloat(form.lat), lng: parseFloat(form.lng), active: true });
      toast.success("Cidade adicionada!");
      setForm({ slug: "", name: "", state: "", lat: "", lng: "" });
      refresh();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  return (
    <div className="max-w-6xl mx-auto px-6 py-12">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <h1 className="font-display text-4xl font-bold text-stone-900">Administração</h1>
          <p className="text-stone-500 mt-1">Gerencie cidades, empresas, planos e a home.</p>
        </div>
        <div className="flex flex-wrap gap-2">
          <a href="/admin/quick-register" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-semibold bg-emerald-700 text-white hover:bg-emerald-800" data-testid="link-admin-quick">⚡ Cadastro Rápido</a>
          <a href="/admin/osm-search" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-semibold bg-blue-700 text-white hover:bg-blue-800" data-testid="link-admin-osm">🌍 Buscar OSM</a>
          <a href="/admin/report" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-semibold bg-stone-900 text-white hover:bg-stone-800" data-testid="link-admin-report">📊 Relatório</a>
          <a href="/admin/cities" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-semibold bg-blue-900 text-white hover:bg-blue-950" data-testid="link-admin-cities">Cidades →</a>
          <a href="/admin/companies" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-semibold bg-blue-900 text-white hover:bg-blue-950" data-testid="link-admin-companies">Empresas →</a>
          <a href="/admin/plans" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-semibold bg-stone-900 text-white hover:bg-stone-800" data-testid="link-admin-plans">Planos →</a>
          <a href="/admin/settings" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-semibold bg-emerald-700 text-white hover:bg-emerald-800" data-testid="link-admin-settings">Taxas →</a>
          <a href="/admin/highlights" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-semibold bg-amber-500 text-amber-950 hover:bg-amber-600" data-testid="link-admin-highlights">Destaques →</a>
          <a href="/admin/slides" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-semibold bg-stone-100 text-stone-900 hover:bg-stone-200" data-testid="link-admin-slides">Slides →</a>
          <a href="/admin/home-sections" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-semibold bg-stone-100 text-stone-900 hover:bg-stone-200" data-testid="link-admin-home-sections">Ordem Home →</a>
          <a href="/admin/segments" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-semibold bg-amber-100 text-amber-900 hover:bg-amber-200" data-testid="link-admin-segments">✨ Segmentos →</a>
          <a href="/admin/blog" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-semibold bg-emerald-100 text-emerald-900 hover:bg-emerald-200" data-testid="link-admin-blog">📰 Blog →</a>
          <a href="/admin/wallets" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-semibold bg-indigo-700 text-white hover:bg-indigo-800" data-testid="link-admin-wallets">💼 Carteiras →</a>
          <a href="/admin/notifications" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-semibold bg-rose-700 text-white hover:bg-rose-800" data-testid="link-admin-notifications">🔔 Notificações →</a>
          <a href="/admin/packages" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-semibold bg-purple-700 text-white hover:bg-purple-800" data-testid="link-admin-packages">📦 Lojinha de Pacotes →</a>
        </div>
      </div>

      <Card className="mt-8 p-6 rounded-2xl border-stone-200">
        <h2 className="font-display text-xl font-semibold mb-4">Nova cidade (configurável)</h2>
        <form onSubmit={addCity} className="grid sm:grid-cols-5 gap-3">
          <div className="sm:col-span-1"><Label>Slug</Label><Input required value={form.slug} onChange={(e) => setForm({...form, slug: e.target.value})} placeholder="recife" className="rounded-xl mt-1" data-testid="city-slug"/></div>
          <div className="sm:col-span-1"><Label>Nome</Label><Input required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} placeholder="Recife" className="rounded-xl mt-1" data-testid="city-name"/></div>
          <div className="sm:col-span-1"><Label>Estado</Label><Input required value={form.state} onChange={(e) => setForm({...form, state: e.target.value})} placeholder="PE" className="rounded-xl mt-1" data-testid="city-state"/></div>
          <div className="sm:col-span-1"><Label>Latitude</Label><Input required value={form.lat} onChange={(e) => setForm({...form, lat: e.target.value})} placeholder="-8.0476" className="rounded-xl mt-1" data-testid="city-lat"/></div>
          <div className="sm:col-span-1"><Label>Longitude</Label><Input required value={form.lng} onChange={(e) => setForm({...form, lng: e.target.value})} placeholder="-34.8770" className="rounded-xl mt-1" data-testid="city-lng"/></div>
          <div className="sm:col-span-5 flex justify-end"><Button type="submit" className="bg-blue-900 hover:bg-blue-950 text-white rounded-xl" data-testid="city-submit">Adicionar cidade</Button></div>
        </form>
      </Card>

      <div className="grid lg:grid-cols-2 gap-6 mt-6">
        <Card className="p-6 rounded-2xl border-stone-200">
          <h2 className="font-display text-xl font-semibold mb-3">Cidades ({cities.length})</h2>
          <ul className="divide-y divide-stone-100">
            {cities.map((c) => (
              <li key={c.slug} className="py-2.5 flex items-center justify-between" data-testid={`admin-city-${c.slug}`}>
                <div>
                  <div className="font-medium text-sm">{c.name} / {c.state}</div>
                  <div className="text-[11px] text-stone-500">{c.slug} · {c.lat}, {c.lng}</div>
                </div>
              </li>
            ))}
          </ul>
        </Card>

        <Card className="p-6 rounded-2xl border-stone-200">
          <h2 className="font-display text-xl font-semibold mb-3">Empresas ({companies.length})</h2>
          <ul className="divide-y divide-stone-100 max-h-80 overflow-y-auto">
            {companies.map((c) => (
              <li key={c.id} className="py-2.5 flex items-center justify-between gap-2">
                <div className="min-w-0">
                  <div className="font-medium text-sm truncate">{c.name}</div>
                  <div className="text-[11px] text-stone-500">{c.city_slug} · {c.category}</div>
                </div>
                <PlanPill plan={c.plan}/>
              </li>
            ))}
          </ul>
        </Card>

        <Card className="p-6 rounded-2xl border-stone-200 lg:col-span-2">
          <h2 className="font-display text-xl font-semibold mb-3">Usuários ({users.length})</h2>
          <ul className="divide-y divide-stone-100 max-h-80 overflow-y-auto">
            {users.map((u) => (
              <li key={u.id} className="py-2.5 flex items-center justify-between">
                <div>
                  <div className="font-medium text-sm">{u.name}</div>
                  <div className="text-[11px] text-stone-500">{u.email}</div>
                </div>
                <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-md bg-stone-100 text-stone-700">{u.role}</span>
              </li>
            ))}
          </ul>
        </Card>
      </div>
    </div>
  );
}
